let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("3Wz8w")).then(() => parcelRequire('j1M7k'));